module.exports = __webpack_public_path__ + "img/2-2-3.2c6c8201.png";